export const filterFullResult = {
  Entities: [
    {
      Properties: {
        FilterCategory: 'Project',
        FilterItems: [
          {
            Id: 46,
            Name: 'LegalEntityProject',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/legal-entity-project/content',
            ChildFilters: ['Project'],
          },
          {
            Id: 53,
            Name: 'ProjectDepartment',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/project-department/content',
            ChildFilters: ['Project'],
          },
          {
            Id: 2,
            Name: 'Customer',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/customer/content',
            ChildFilters: ['Project'],
          },
          {
            Id: 5,
            Name: 'ProjectManager',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/project-manager/content',
            ChildFilters: ['Project'],
          },
          {
            Id: 6,
            Name: 'AccountManager',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/account-manager/content',
            ChildFilters: ['Project'],
          },
          {
            Id: 8,
            Name: 'ProjectType',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/project-type/content',
            ChildFilters: ['Project'],
          },
          {
            Id: 51,
            Name: 'ProjectStatus',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/project-status/content',
            ChildFilters: ['Project'],
          },
          {
            Id: 3,
            Name: 'Project',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/project/content',
            ChildFilters: ['Task'],
            ParentFilters: [
              'ProjectManager',
              'ProjectDepartment',
              'Customer',
              'ProjectStatus',
              'LegalEntityProject',
            ],
          },
          {
            Id: 20,
            Name: 'Task',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/task/content',
            ParentFilters: ['Project', 'TaskStatus'],
          },
        ],
      },
    },
    {
      Properties: {
        FilterCategory: 'ResourceManagement',
        FilterItems: [
          {
            Id: 47,
            Name: 'LegalEntityEmployee',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/legal-entity-employee/content',
            ChildFilters: ['Employee'],
          },
          {
            Id: 41,
            Name: 'ApprovalManager',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/approval-manager/content',
            ChildFilters: ['Employee'],
          },
          {
            Id: 54,
            Name: 'EmployeeDepartment',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/employee-department/content',
            ChildFilters: ['Employee'],
          },
          {
            Id: 24,
            Name: 'EmployeeType',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/employee-type/content',
            ChildFilters: ['Employee'],
          },
          {
            Id: 12,
            Name: 'Employee',
            Type: 'MultiSelectTypeSearch',
            ContentUrl: 'api/v2/filters/employee/content',
            ParentFilters: [
              'ApprovalManager',
              'EmployeeType',
              'EmployeeDepartment',
              'LegalEntityEmployee',
            ],
          },
        ],
      },
    },
  ],
  Links: [
    {
      Href: 'https://app8.timelog.com/npo_sandbox/api/v2/filters/list/NewResourcePlanner',
      Rel: 'self',
    },
  ],
};
